import { render, staticRenderFns } from "./ListaTiendas.vue?vue&type=template&id=46a451ee&scoped=true&"
import script from "./ListaTiendas.vue?vue&type=script&lang=js&"
export * from "./ListaTiendas.vue?vue&type=script&lang=js&"
import style0 from "./ListaTiendas.vue?vue&type=style&index=0&id=46a451ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a451ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
